import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { openCustomModal } from '../../../../actions/modal';
import Form from '../../../../common/Form';
import { useForm } from 'react-hook-form';
import { UpdatePOTable } from './UpdatePoTable';
import ButtonScogoPrimary from '../../../../common/Buttons/ButtonScogoPrimary';
import ButtonScogoClosedOutlined from '../../../../common/Buttons/ButtonScogoClosedOutlined';
import PayPoTax from '../PayPoTax';
import { useNavigate } from 'react-router-dom';
import { isPayPOAllowed } from '../../../../utils/access';

const arrayName = 'quotes';
const formName = 'updatePo';

const UpdatePo = (props) => {
    const { poData } = props;
    const formButtonLoading = useSelector((state) => state.loading.formButtonLoading);

    const submitRef = useRef(null)

    const defaultValues = {};

    const methods = useForm({ defaultValues, mode: 'all' });

    return (
        <div className='bg-white overflow-hidden'>
            <Form
                className='w-full bg-white'
                onSubmit={() => { }}
                submitButtonText='Submit'
                submitContainerClassName='flex gap-2 justify-end py-4 px-4'
                methods={methods}
                submitRef={submitRef}
            >
                <div className='relative h-full flex overflow-hidden bg-white'
                    style={{
                        flexFlow: 'column',
                        height: '63vh'
                    }}
                >
                    <div className='flex flex-col flex-auto px-5 py-3 overflow-hidden'>
                        <UpdatePOTable
                            vendors={[]}
                            poData={poData}
                            arrayName={arrayName}
                            poCategoryOptions={[]}
                            assetTypeOptions={[]}
                            line_items={poData.line_items}
                        />
                    </div>
                    <div className='flex flex-initial justify-end py-3 px-5'>
                        <RenderFormButtons isLoading={formButtonLoading[formName]} isDisabled={false} poData={poData} submitRef={submitRef} />
                    </div>
                </div>

            </Form>
        </div>
    );
};

export default UpdatePo;

const RenderFormButtons = ({ poData }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const newLoggedUserData = useSelector((state) => state.auth.newLoggedUserData);

    const onPayPoTaxClick = () => {
        dispatch(
            openCustomModal({
                heading: (
                    <>
                        Pay PO Tax | <span className='text-scogobgsky'>{poData.po_number || poData.pr_number}</span>
                    </>
                ),
                modalWidth: '70rem',
                modalHeight: 'auto',
                modalComponent: <PayPoTax poData={poData} />,
            })
        );
    };

    const isPoCancelled = poData.status === 'CANCELLED';
    const isPoNotApproved = poData.status !== 'APPROVED';


    return <div className='flex items-center gap-2'>
        {isPayPOAllowed(newLoggedUserData.actions) && <ButtonScogoPrimary
            disabled={isPoCancelled || isPoNotApproved}
            textOrComponent={'Pay PO Tax'}
            loading={false}
            onClick={onPayPoTaxClick}
            type={"button"}
            onHoverTitle={isPoCancelled ? 'PO is cancelled' : 'PO is not Approved'}
        />}
        <ButtonScogoClosedOutlined textOrComponent='Cancel' type='button' onClick={() => navigate(-1)} />
    </div>
}